import { create } from 'zustand';

interface DistributionState {
  showInvite: boolean;
  showNewUserMode2Tip: boolean;
  newUserCredits: number;
  inviteUrl: string;
  hasClickedIcon: boolean;
  hasShownFirstLoginBubble: boolean;
  setShowInvite: (show: boolean) => void;
  setShowNewUserMode2Tip: (show: boolean) => void;
  setNewUserCredits: (credits: number) => void;
  setInviteUrl: (url: string) => void;
  setHasClickedIcon: (clicked: boolean) => void;
  setHasShownFirstLoginBubble: (shown: boolean) => void;
}

const DistributionStore = create<DistributionState>((set) => ({
  showInvite: false,
  showNewUserMode2Tip: false,
  newUserCredits: 0,
  inviteUrl: '',
  hasClickedIcon: false,
  hasShownFirstLoginBubble: false,
  setShowInvite: (show) => set({ showInvite: show }),
  setShowNewUserMode2Tip: (show) => set({ showNewUserMode2Tip: show }),
  setNewUserCredits: (credits) => set({ newUserCredits: credits }),
  setInviteUrl: (url) => set({ inviteUrl: url }),
  setHasClickedIcon: (clicked) => set({ hasClickedIcon: clicked }),
  setHasShownFirstLoginBubble: (shown) => set({ hasShownFirstLoginBubble: shown }),
}));

export default DistributionStore;
